import { modalToastQueue } from '@/components/ui/molecules/GlobalToastRegions';
import { useCustomToastQueue } from './useCustomToastQueue.hook';

export const useModalToastQueue = () => {
    const state = useCustomToastQueue(modalToastQueue);
    return state;
};
